import '@backstage/cli/asset-types';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Backstage UI (BUI) base stylesheet. The upgraded catalog AboutContent uses
// the new @backstage/ui Grid + --bui-* variables; without this the About card
// grid collapses to a vertical stack and borders/dividers disappear.
import '@backstage/ui/css/styles.css';
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
